import { render } from "./QuestionExamplePhoneticVowel.vue?vue&type=template&id=68beae8b&scoped=true"
import script from "./QuestionExamplePhoneticVowel.vue?vue&type=script&lang=js"
export * from "./QuestionExamplePhoneticVowel.vue?vue&type=script&lang=js"

import "@/css/components/question-example-phonetic-vowel.css?vue&type=style&index=0&id=68beae8b&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68beae8b"]])

export default __exports__